import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { toast } from 'sonner';
import { useAuth } from '../lib/auth';
import { formatApiError } from '../lib/api';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import AuthShell from '../components/AuthShell';
import { User, Mail, Lock, Phone } from 'lucide-react';

export default function Register() {
  const { register } = useAuth();
  const navigate = useNavigate();
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (password.length < 6) { toast.error('Şifre en az 6 karakter olmalı'); return; }
    setLoading(true);
    try {
      const user = await register(email, password, name, phone);
      toast.success(`Hosgeldin ${user.name}! Hesabin olusturuldu. Mail kutunu kontrol et.`);
      navigate('/verify-pending');
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthShell
      title="Üye Ol"
      subtitle="E-posta onaylı hesabını oluştur, premium kaynaklara saniyeler içinde eriş."
      footer={<p className="text-center text-sm text-muted-foreground mt-6">Zaten hesabın var mı? <Link to="/login" className="text-fuchsia-300 hover:text-white">Giriş yap</Link></p>}
    >
      <form onSubmit={submit} className="space-y-4" data-testid="register-form">
        <div className="space-y-1.5">
          <Label htmlFor="name">Ad Soyad</Label>
          <div className="relative auth-input-wrap"><User className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-muted-foreground" /><Input id="name" value={name} onChange={(e)=>setName(e.target.value)} placeholder="Ahmet Yılmaz" className="pl-9 auth-input" data-testid="register-name-input" required /></div>
        </div>
        <div className="space-y-1.5">
          <Label htmlFor="email">E-posta</Label>
          <div className="relative auth-input-wrap"><Mail className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-muted-foreground" /><Input id="email" type="email" value={email} onChange={(e)=>setEmail(e.target.value)} placeholder="ornek@mail.com" className="pl-9 auth-input" data-testid="register-email-input" required /></div>
        </div>
        <div className="space-y-1.5">
          <Label htmlFor="phone">Telefon <span className="text-xs text-muted-foreground">(opsiyonel)</span></Label>
          <div className="relative auth-input-wrap"><Phone className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-muted-foreground" /><Input id="phone" type="tel" value={phone} onChange={(e)=>setPhone(e.target.value)} placeholder="+90 555 ..." className="pl-9 auth-input" data-testid="register-phone-input" /></div>
        </div>
        <div className="space-y-1.5">
          <Label htmlFor="password">Şifre <span className="text-xs text-muted-foreground">(en az 6 karakter)</span></Label>
          <div className="relative auth-input-wrap"><Lock className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-muted-foreground" /><Input id="password" type="password" value={password} onChange={(e)=>setPassword(e.target.value)} placeholder="••••••••" className="pl-9 auth-input" data-testid="register-password-input" required minLength={6} /></div>
        </div>
        <Button type="submit" disabled={loading} className="w-full premium-cta" data-testid="register-submit-btn">
          {loading ? 'Hesap oluşturuluyor...' : 'Hesap Oluştur'}
        </Button>
      </form>
    </AuthShell>
  );
}
